export type ContactPayload = {
  name: string;
  email: string;
  phone: string;
  text: string;
  token: string;
};

export async function submitContactForm(payload: ContactPayload, contactApiUrl: string): Promise<void> {
  const response = await fetch(contactApiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: payload.name,
      email: payload.email,
      phone: payload.phone,
      text: payload.text,
      token: payload.token,
    }),
  });

  if (!response.ok) {
    throw new Error('Contact request failed');
  }
}
